import { useRef, useCallback } from "react";

// Retries a callback with a fixed delay, up to maxAttempts times, then gives up silently
// instead of recursing forever when a token never becomes available. Does not redirect:
// the retried callback can close over a stale Token from the render it was scheduled in
// (most of these callers aren't memoized), so "still no token after N attempts" doesn't
// reliably mean the user is actually logged out - it's safer to just stop than to force-navigate.
export function useCappedRetry(maxAttempts = 10, delayMs = 500) {
	const attemptsRef = useRef(0);

	return useCallback((callback) => {
		attemptsRef.current += 1;
		if (attemptsRef.current > maxAttempts) {
			return;
		}
		setTimeout(callback, delayMs);
	}, [maxAttempts, delayMs]);
}
